import { render } from "./EditEmployeeReport.vue?vue&type=template&id=0b4140eb&scoped=true"
import script from "./EditEmployeeReport.vue?vue&type=script&lang=js"
export * from "./EditEmployeeReport.vue?vue&type=script&lang=js"

import "./employee-report.scss?vue&type=style&index=0&id=0b4140eb&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4140eb"]])

export default __exports__